import Vue from 'vue'
import VModal from 'vue-js-modal'

const defaultOptions = { dialog: true }

Vue.use(VModal, defaultOptions)
